import { render } from "./CadastroTelasView.vue?vue&type=template&id=15a1eca4"
import script from "./CadastroTelasView.vue?vue&type=script&lang=js"
export * from "./CadastroTelasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__